'use client'
import { Box, Icon, Typography } from '@/CommonComponents'
import { useTexts } from '@/contexts/LanguageContext'
export default function UnderMaintenance() {
  const { UNDER_MAINTENANCE } = useTexts()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Icon icon="handyman-outlined" />
      <Typography variant="body2" sx={{ textAlign: 'center', fontStyle: 'italic' }}>
        {UNDER_MAINTENANCE}
      </Typography>
    </Box>
  )
}
